import { render, staticRenderFns } from "./fdInventory38.vue?vue&type=template&id=639acd4a"
import script from "./fdInventory38.vue?vue&type=script&lang=js"
export * from "./fdInventory38.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports